<head>

<script src="https://unpkg.com/vue"></script>
</head>
<template>
  <br />
  <div class="row" style="margin-bottom: 10px">
    <span class="page-title">Bloquear Agenda</span>
  </div>

  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
      <label for="cpf">CPF</label><br />
      <input type="text" class="form-control form-input-component" v-mask="'###.###.###-##'" ref="cpf" v-model="dataUser.cpf" id="cpf" readonly disabled />
    </div>

    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
      <label for="nome">Nome</label><br />
      <input type="text" class="form-control form-input-component" v-model="dataUser.nome" id="nome" readonly disabled />
    </div>

    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
      <label>Especialidade</label><br />
      <input type="text" class="form-control form-input-component" v-model="profissional.especialidade.nome" readonly disabled />
    </div>
  </div>
  <br />
  <form class="row needs-validation" novalidate id="frmBloqueioAgenda" name="frmBloqueioAgenda">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
        <label>Data Inicial</label>
        <input type="text" v-model="form.dtInicial" class="form-control form-input-component" id="dtInicial" ref="dtInicial" v-mask="'##/##/####'" placeholder="Ex: 20/02/2023" v-bind:class="{ 'is-invalid': submitted && !form.dtInicial }" required />
      </div>

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
        <label for="horaInicio">Hora de início</label>
        <input type="text" v-model="form.horaInicio" v-mask="'##:##'" required v-bind:class="{ 'is-invalid': submitted && !form.horaInicio }" ref="horaInicio" class="form-control form-input-component" id="horaInicio" />
      </div>

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
        <label>Data Final</label>
        <input type="text" v-model="form.dtFinal" class="form-control form-input-component" id="dtFinal" v-mask="'##/##/####'" placeholder="Ex: 20/02/2023" v-bind:class="{ 'is-invalid': submitted && !form.dtFinal }" ref="dtFinal" required />
      </div>

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
        <label for="horaFim">Hora final</label>
        <input type="text" v-model="form.horaFim" v-mask="'##:##'" required v-bind:class="{ 'is-invalid': submitted && !form.horaFim }" ref="horaFim" class="form-control form-input-component" id="horaFim" />
      </div>

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-6">
        <label for="tipoBloqueio">Tipo Bloqueio</label>
        <select class="form-select" v-model="form.tipoBloqueio" required id="tipoBloqueio" v-bind:class="{ 'is-invalid': submitted && !form.tipoBloqueio }">
          <option value="FERIAS">Férias</option>
          <option value="SAUDE">Saúde</option>
          <option value="OUTRO">Outro</option>
          <option value="FERIADO">Feriado</option>
        </select>
      </div>

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-6">
        <label>Justificativa do Bloqueio</label>
        <input type="text" v-model="form.justificativa" class="form-control form-input-component" id="justificativa" v-bind:class="{ 'is-invalid': submitted && !form.justificativa }" required />
      </div>
    </div>

    <div class="row">
      <div class="col-3">
        &nbsp;<br />
        <button type="button" class="btn btn-primary" @click="saveAndContinue(v$.form.$invalid)">Salvar</button>
      </div>
    </div>
  </form>
  <br />
  <a-table :dataSource="listaBloqueioAgenda" :columns="columns" :key="id">
    <template v-if="column.key === 'dataInicial'">
      <span> {{ new Date(record.dataInicial).toLocaleString() }} asdfasdf </span>
    </template>
    <template #action="{ record }">
      <a @click="desabilitar(record)"><i class="fas fa-trash-can icon-trash-can"></i></a>
    </template>
    <!--
        <template #unidade="{ record }">
            <a-popconfirm
                v-if="dataSource.length"
                title="Confirma exclusão ?"
                @confirm="onDelete(record.key)">
                <a>Delete</a>
            </a-popconfirm>
        </template>
        -->
  </a-table>

  <!--
    <div style="height: max-content">
      <vue-cal
          class="vuecal--full-height-delete vuecal--blue-theme "
          locale="pt-br"
          hide-view-selector
          :time-from="6*60"
          :timeTo="20*60"
          :disable-views="['years','year','month','day']"
          :hide-weekdays="[]"
          :editable-events="{title: false, create : true, delete: true, resize: true, drag: false, drag: true}"
          :resizeX="true"
          :snapToTime="60"
          :dragToCreateEvent='true'
          :minDate="new Date()"
          :on-event-create="onEventCreate"

      />
    </div>

  -->
</template>

<script>
import { getDataUser } from '@/utils';
import { getProfissionalByCpf } from '@/components/service/profissionalService';
import { required } from '@vuelidate/validators';
import { openNotification, typesNotification } from '@/utils/notifications';
import { useVuelidate } from '@vuelidate/core';
import { desabilitar, bloquear, listarBloqueios } from '@/components/service/agenda-bloqueio';
import { isValidTime, isValidDate } from '@/utils/servicos-utils';

export default {
  name: 'PageBloquearAgenda',
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      listaBloqueioAgenda: [],
      dataUser: getDataUser(),
      profissional: undefined,
      submitted: false,
      form: {
        cpfProfissional: undefined,
        dtInicial: undefined,
        horaInicio: undefined,
        dtFinal: undefined,
        horaFim: undefined,
        tipoBloqueio: undefined,
        justificativa: undefined,
        status: undefined,
      },
      columns: [
        {
          title: 'Data Inicial',
          dataIndex: 'dtInicial',
          key: 'dtInicial',
        },
        {
          title: 'Hora Início',
          dataIndex: 'horaInicio',
          key: 'horaInicio',
        },
        {
          title: 'Data Final',
          dataIndex: 'dtFinal',
          key: 'dtFinal',
        },
        {
          title: 'Hora Fim',
          dataIndex: 'horaFim',
          key: 'horaFim',
        },
        {
          title: 'Tipo Bloqueio',
          dataIndex: 'tipoBloqueio',
          key: 'tipoBloqueio',
        },
        {
          title: 'Justificativa',
          dataIndex: 'justificativa',
          key: 'justificativa',
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  validations() {
    return {
      form: {
        dtInicial: {
          required,
        },
        horaInicio: {
          required,
        },
        dtFinal: {
          required,
        },
        horaFim: {
          required,
        },
        tipoBloqueio: {
          required,
        },
        justificativa: {
          required,
        },
      },
    };
  },
  methods: {
    async desabilitar(rec) {
      await desabilitar(rec.id)
        .then(() => {
          openNotification(typesNotification.success, 'Bloqueio inativado com sucesso!');
          this.atualizarTabela();
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
          openNotification(typesNotification.error, 'Falha na exclusão de Alocação da Agenda!');
        });
    },
    atualizarTabela() {
      listarBloqueios(this.profissional.cpf).then((rs) => {
        this.listaBloqueioAgenda = rs.data;
      });
    },
    recuperarProfissionalLogado() {
      getProfissionalByCpf(this.dataUser.cpf)
        .then((r) => {
          this.profissional = r.data;
          this.atualizarTabela();
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Usuário não cadastrado como Profissional de Saúde!');
        });
    },
    // eslint-disable-next-line no-unused-vars
    async saveAndContinue(invalid) {
      this.submitted = invalid;
      if (invalid) {
        openNotification(typesNotification.error, 'Informe os campos obrigatórios');
      } else {
        if (!isValidDate(this.form.dtInicial)) {
          this.$refs.dtInicial.focus();
          openNotification(typesNotification.error, 'Data Inicial Inválida');
          return;
        }
        if (!isValidTime(this.form.horaInicio)) {
          this.$refs.horaInicio.focus();
          openNotification(typesNotification.error, 'Hora de início Inválida');
          return;
        }
        if (!isValidDate(this.form.dtFinal)) {
          this.$refs.dtFinal.focus();
          openNotification(typesNotification.error, 'Data Final Inválida');
          return;
        }
        if (!isValidTime(this.form.horaFim)) {
          this.$refs.horaFim.focus();
          openNotification(typesNotification.error, 'Hora Final Inválida');
          return;
        }

        this.form.cpfProfissional = this.profissional.cpf;
        await bloquear(this.form).then(() => {
          openNotification(typesNotification.success, 'Bloqueio efetuado com sucesso.');
          this.atualizarTabela();
        });
        this.form.horaInicio = '';
        this.form.horaFim = '';
        this.$nextTick(() => {
          // This callback will only be called after the
          // DOM has been updated
          this.$refs.dtInicio.focus();
        });
      }
    },
  },
  created() {
    this.recuperarProfissionalLogado();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}
</style>
